<h1 class="ui yellow header">
  <i class="warning sign icon"></i>
  Une erreur est survenue
</h1>
<div class="content">
  <p>Il semble que votre version de l'application ne soit plus à jour.</p>
  <p>Pour corriger le problème, l'application va être mise à jour et redémarrée.</p>
</div>
<div class="actions">
  <div class="ui basic inverted primary button" (click)="modal.approve()">Ok</div>
</div>
